import _ from 'lodash'
import { getVar } from '@/common_util/misc/environment'
import cnRoles from './cnRoles'

let API = process.env.VUE_APP_ACCOUNT_SERVICE_URI + '/user-service/admin'
let CLIENT_ID = process.env.VUE_APP_CLIENT_ID
let baseAuthServer = process.env.VUE_APP_PASSPORT_URI
const baseAccountServer = process.env.VUE_APP_ACCOUNT_SERVICE_URI
const clientName = 'admin-console'

/** 环境变量修改， 请编辑  .env.development 文件 */
// if (NODE_ENV === 'development') {
// qa
// API = 'https://qa-console-service.zhihuiya.com'
// baseAuthServer = 'https://qa-passport.zhihuiya.com'
// baseAccountServer = 'https://qa-account-service.zhihuiya.com'
// CLIENT_ID = '10'
// ci
// API = 'https://ci-console-service.zhihuiya.com'
// baseAuthServer = 'https://ci-passport.zhihuiya.com'
// baseAccountServer = 'https://ci-account-service.zhihuiya.com'
// CLIENT_ID = '10'
// release us
// API = 'https://release-admin-service.patsnap.com'
// baseAuthServer = 'https://release-passport.patsnap.com'
// CLIENT_ID = 'c9c9d342d4d94800b65ab527bc0321c5'

// release cn
// API = 'https://release-admin-service.zhihuiya.com'
// baseAuthServer = 'https://release-passport.zhihuiya.com'
// baseAccountServer = 'https://release-account-service.zhihuiya.com'
// // 和线上一样的
// CLIENT_ID = '9d79d06908844c068fafc7e8c2302c77'

// prod us
// API = 'https://admin-service.patsnap.com'
// baseAuthServer = 'https://passport.patsnap.com'
// CLIENT_ID = '85e33fd899b94fa78f1f5fc608d11c4f'

// prod cn
// API = 'https://admin-service.zhihuiya.com'
// baseAuthServer = 'https://passport.zhihuiya.com'
// CLIENT_ID = '9d79d06908844c068fafc7e8c2302c77'

// API = 'http://192.168.6.173:8080'
// API = 'http://localhost:8080'
// }

const API_debug = localStorage.getItem('API')
const baseAuthServer_debug = localStorage.getItem('baseAuthServer')
const CLIENT_ID_debug = localStorage.getItem('CLIENT_ID')

if (API_debug) {
    API = API_debug
}
if (baseAuthServer_debug) {
    baseAuthServer = baseAuthServer_debug
}
if (CLIENT_ID_debug) {
    CLIENT_ID = CLIENT_ID_debug
}

if (API_debug || baseAuthServer_debug || CLIENT_ID_debug) {
    const timestamp = localStorage.getItem('timestamp')
    if (!timestamp) {
        localStorage.setItem('timestamp', new Date().getTime())
    } else if (Number(timestamp) + 10 * 60 * 1000 < new Date().getTime()) {
        localStorage.removeItem('API')
        localStorage.removeItem('baseAuthServer')
        localStorage.removeItem('CLIENT_ID')
        localStorage.removeItem('timestamp')
    }
}

export default {
    get_company: id => `${API}/tenants/tenant/company_id=${id}`,
    get_user_list: `${API}/users`,
    batch_get_user_disable: `${API}/users/disable`,
    get_user: id => `${API}/users/user/${id}`,
    add_user: `${API}/users/user`,
    batch_reset_user_password: `${API}/users/user/reset-password`,
    import_user: `${API}/users/import`,
    get_statistics: `${API}/statistics/legacy`,
    get_private_key: `${baseAuthServer}/public/request_public_key`,
}

let roleMap = {
    10: 'Database',
    17971: 'Landscape',
    17969: 'Workspace Reader License',
    17994: 'Image Search',
    17996: 'Insights',
    dc3a37ffb5fb46388b973b2a330f2b49: 'Non-Patent Literature',
    b13bc4c777344c6eae23265bd1a91a4d: 'Licensee Locator',
    ffe60f312565caed3238324a9427fecd: 'Chemical',
    bb09759e041d461183a9f48af57fe222: 'Chemical Polymer',
    '287dcd9cad8f499dabecca0e9e034f4b': 'Portfolio Pruning Playbook',
    '16dc48b699534d84b9a812c2ed0e073d': 'Bio',
    '5429e0cbcb184db4bfa3ebdcf994bd5b': 'Discovery',
    '907eb993218748fda9749c8a7c1fde5c': 'Workspace 100k',
}

const roleMapCnArr = cnRoles.map(e => ({ id: e.id, role_name: e.role_name }))

let isCn = false
let isEu = false

const region = getVar('region')
if (_.isString(region)) {
    isCn = _.toUpper(region) === 'CN'
    isEu = _.toUpper(region) === 'EU'
} else {
    isCn = baseAuthServer.includes('passport.zhihuiya.com')
    if (baseAuthServer.includes('ci-passport')) {
        isCn = false
    }
    if (baseAuthServer.includes('qa-passport')) {
        isCn = true
    }
    isEu = baseAuthServer.includes('passport.patsnap.eu')
}

// TODO
// isCn = true
// isCn = false

if (isCn) {
    roleMap = {}
    roleMapCnArr.forEach(e => {
        roleMap[e.id] = e.role_name
    })
}

const clientId = CLIENT_ID
export { roleMap, baseAuthServer, clientId, baseAccountServer, clientName }

const codes = [

    20109,
    30129,
    31101,
    30101,
    30301,
    31110, // 编辑安全设置 allow_external 为false
    31114, // 创建的team group name 重复
    30139, // 后端的提示errors.com.patsnap.account.company_domain_restriction可以去掉
    31113, // 访问不存在的页面
    600014,
    600020, /** 编辑用户接口 邮箱占用 */
    600021, /** 编辑用户接口 手机占用 */
    600022 /** 编辑用户接口 手机和邮箱占用 */
]
export { codes }
export { API }

// if (false) {
//     const ciToken = {
//         "token": "eyJhbGciOiJSUzI1NiJ9.eyJ0ZW5hbnRfaWQiOiIxNDI3ZmY2OWIxZTQ0MGNiOTZiY2U0YjM0ODc1MTIxMSIsInN1YiI6ImVhODJjMTRjNmNhNDRkOTc5ZWNjNGY0ZGJiMmQ5YjJhIiwic2Vzc2lvbiI6Ijk4MGFlNDU2YzU0YzRiM2NiMzVlMWRiOGU3YjIzYTUzIiwiaXNzIjoicGF0c25hcCIsImV4cCI6MTU0ODY0ODY5MywiaWF0IjoxNTQ4NjQ2ODkzLCJqdGkiOiJjYjg0MjU5ZC01YWQ0LTRlMTUtOGUwMS1iNTBlZmE0OWMyN2UiLCJjbGllbnRfaWQiOiIxMCIsImF1dGhvcml0aWVzIjpbIjI0Zjg5NDg5ZTk2MTRjMjBhNjY2NTRkMGNjNzBhY2IzIiwiNGRmMjEyOTI4YTI5NDdmNmI2YWE3M2FiYjJjMGI0NmYiLCI1ZWI2ZTBhOTc3Mjk0MGYxODUwNzdlYzhjYzljZWQyNyIsIjg5ZmMxNzcwMmNjNzRlZmViMWFmZmZlMzA5ZWFmNmQ1IiwiYTg3Mzk5NDk3MTFjNDI1ZjhhMmE5YTIzNTY0MjYxZmYiLCJiYWNrb2ZmaWNlLWRldmVsb3BlciIsImNvdXJzZV9jdXN0b21fZWVhOTdlMzBjMzc0ZWMzMzUwNjQ2YWRlZjYxNzAzYjUiLCJjb3Vyc2VfY3VzdG9tX3Bhc3Nwb3J0XzllOTY4YTkyMGIyYWQ1NDFiODVkMzVmNmQ3N2FkMzNmIiwiY291cnNlX3B1YmxpY19kYWNiYmExMmZhZmMxZDI2NWZiOWZlMWE1Nzc0ZGY5NCIsImNvdXJzZV9zdXBlcl92aXBfYTRmZGU1MTAxODg3NTZjZWI0OGJiODhiNjVhOWM0YmQiLCJjb3Vyc2VfdmlwXzNkNjMyNGY5NTVhNjk4Mjg2MDFkOThmMWY2NDg0NmZjIl19.G9t3DAuyNK6TJLO00OKEsCzGrkelkI9S7YowIEct67_Mkm6cn0jvOFbWBlgu27sgmxLARFWKWq_t7WSIwjm7ES41bVXDXyb7CfyNlXloX9s9Tb5Qja9wd94iIFnBex-d6g4G--zVeBtpOkIk4iFxoBho5gjG_qp2lMkR2Ub10JY",
//         "refreshToken": "eyJhbGciOiJSUzI1NiJ9.eyJ0ZW5hbnRfaWQiOiIxNDI3ZmY2OWIxZTQ0MGNiOTZiY2U0YjM0ODc1MTIxMSIsInN1YiI6ImVhODJjMTRjNmNhNDRkOTc5ZWNjNGY0ZGJiMmQ5YjJhIiwic2Vzc2lvbiI6Ijk4MGFlNDU2YzU0YzRiM2NiMzVlMWRiOGU3YjIzYTUzIiwiYXRpIjoiY2I4NDI1OWQtNWFkNC00ZTE1LThlMDEtYjUwZWZhNDljMjdlIiwiaXNzIjoicGF0c25hcCIsImV4cCI6MTU0ODY1NDA5MywiaWF0IjoxNTQ4NjQ2ODkzLCJqdGkiOiJkMDVhOTZlMi1mYTNmLTRhNjQtOTNhMy1kYWI1NTJmNmRmNjUiLCJjbGllbnRfaWQiOiIxMCIsImF1dGhvcml0aWVzIjpbIlJPTEVfUkVGUkVTSF9UT0tFTiJdfQ.ZsWtCKYR65_yt3ED60BEuZtWuAFyDStjQK3Cq27pVan0RXYU3WkhBV5QK-n0rqbabf4L2OxdQOgYtuoEcTZByDX7ZY1eFoeza6VlROlvk1LaE-r7fhsVcUwfzQvzc4WGrXDTSju9xGRNTPAD9vBY2Ps5LwCVYxw_HZvAQu6JZ0Q",
//         "tokenExpires": 2548648633762,
//         "refreshTokenExpires": 2548654033762
//     }
//     localStorage.setItem('patsnap-authorizations', JSON.stringify(ciToken))
// }

/*
 *

 localStorage.setItem('patsnap-authorizations','{"token":"eyJhbGciOiJSUzI1NiJ9.eyJ0ZW5hbnRfaWQiOiI5OTYxOTExZTE1YTU0ZDQ5YWM3ZjdjYzY1ZmY1NTM1YSIsInN1YiI6IjdkNmM0MjFlMzNmNjQ0NTZhNGE5YTFjZTcwZWRiYjc0Iiwic2Vzc2lvbiI6ImU2OWE1ZWFhMGU0NTQ1NDJhYzg2NmYyYjE2NjY3N2QwIiwiaXNzIjoicGF0c25hcCIsImV4cCI6MTU0ODQwMDU0NCwiaWF0IjoxNTQ4Mzk4NzQ0LCJqdGkiOiJmMTA3OTI0Mi1hN2YxLTRjNWQtOTVlOS1lODU3YTI5MTUxYjgiLCJjbGllbnRfaWQiOiJjOWM5ZDM0MmQ0ZDk0ODAwYjY1YWI1MjdiYzAzMjFjNSIsImF1dGhvcml0aWVzIjpbImJhY2tvZmZpY2UtYWRtaW4iLCJiYWNrb2ZmaWNlLWRldmVsb3BlciJdfQ.JRUPJRPBeW0w3mWXAu2doIjWRGjfOnCvdMLE0scDltSzIzSf6fJOCVbs9bJLM2F7LAGDB6lmwAUODh4vbLeRhSZc-OAdpBp2PgawdYsyUQC9CE3jbf2JMRWdsdOGIwU0G2dtFgFA-QBlDZzzL_sEUYw4DJjMEHKgs2Vd7bKz82E","refreshToken":"eyJhbGciOiJSUzI1NiJ9.eyJ0ZW5hbnRfaWQiOiI5OTYxOTExZTE1YTU0ZDQ5YWM3ZjdjYzY1ZmY1NTM1YSIsInN1YiI6IjdkNmM0MjFlMzNmNjQ0NTZhNGE5YTFjZTcwZWRiYjc0Iiwic2Vzc2lvbiI6ImU2OWE1ZWFhMGU0NTQ1NDJhYzg2NmYyYjE2NjY3N2QwIiwiYXRpIjoiZjEwNzkyNDItYTdmMS00YzVkLTk1ZTktZTg1N2EyOTE1MWI4IiwiaXNzIjoicGF0c25hcCIsImV4cCI6MTU0ODQwNTk0NCwiaWF0IjoxNTQ4Mzk4NzQ0LCJqdGkiOiJiMTM3ZGQ4OC1lMmRkLTRjNTAtOGNlNy02NDZmNWQ3OGU0ZmYiLCJjbGllbnRfaWQiOiJjOWM5ZDM0MmQ0ZDk0ODAwYjY1YWI1MjdiYzAzMjFjNSIsImF1dGhvcml0aWVzIjpbIlJPTEVfUkVGUkVTSF9UT0tFTiJdfQ.AX16i-MZMhovMckT0Uo8FaaX72MGykJ3oYJPpJdSdqF3Usv2Kfvlhyv99aND_svktMjpCiujVfCidjFySithLnLKEVVfkRv6N2ASFPlAfhxcnIaI2pGH2IcBwTboYID-AFKUrhwgKX9n9q2Vw1Sg2vpQkNgDSsz__LK8r-M-kDw","tokenExpires":1548400484241,"refreshTokenExpires":1548405884241}')

 *
 * */

export { isCn, isEu }
